/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const PartnerOverviewPage = lazyLoad(
  () => import('./index'),
  module => module.PartnerOverviewPage
);
